import { AddCircle, Copy } from "react-solar-set/essentionalui";
import Button from "../../components/ui/Button";
import ProfilePic from "../../assets/images/photonobg.png";
import { motion } from "framer-motion";
import { AnimatedSection } from "../../components/ui/AnimatedSection";

export const HeroSection = () => {
    const copyEmail = () => {
        navigator.clipboard.writeText("aaladan453@gmail.com");
        alert("Email copied to clipboard!");
    };

    return (
        <div className="mx-4 sm:mx-10 flex flex-col md:flex-row gap-8 md:gap-4 items-center">
            {/* Texts */}
            <AnimatedSection>
                <div className="flex flex-col w-full md:w-3/4 text-center md:text-left">
                    <motion.h3
                        className="text-white/50"
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5 }}
                    >
                        Hi there 👋
                    </motion.h3>
                    <motion.h1
                        initial={{ opacity: 0, y: 5 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5, delay: 0.2 }}
                    >
                        I'm Abdulalim Ladan
                    </motion.h1>
                    <motion.h3
                        initial={{ opacity: 0, y: 5 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5, delay: 0.4 }}
                    >
                        Flutter/iOS dev who writes clean backends in FastAPI.
                        CTO by day, indie app builder by night. I like UIs that
                        feel native and APIs that don’t fight back.
                        <br />
                        <br />
                        <span className="font-bold">
                            From Kaduna, building from the backend to the app
                            store.
                        </span>
                    </motion.h3>
                    <motion.div
                        className="flex gap-1.5 mt-6 justify-center md:justify-start"
                        initial={{ opacity: 0, y: 5 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5, delay: 0.6 }}
                    >
                        <Button
                            href="/hire-me"
                            variant="Solid"
                        >
                            <AddCircle
                                size={18}
                                iconStyle="LineDuotone"
                                marginHeight={0}
                                color="#ffffff"
                            />
                            <span className="text-sm">Hire Me</span>
                        </Button>
                        <Button
                            type="button"
                            variant="Outline"
                            onClick={copyEmail}
                        >
                            <Copy
                                size={18}
                                iconStyle="LineDuotone"
                                marginHeight={0}
                                color="#ffffff"
                            />
                            <span className="text-sm">Copy Email</span>
                        </Button>
                    </motion.div>
                </div>
            </AnimatedSection>

            {/* Image */}
            <motion.div
                className="w-full md:w-1/4 flex justify-center items-center min-h-[180px]"
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: 0.3 }}
            >
                <div className="flex items-center justify-center w-40 h-40">
                    <img
                        src={ProfilePic}
                        alt="Abdulalim Ladan"
                        className="w-40 h-40 object-cover rounded-full border-4 border-button"
                    />
                </div>
            </motion.div>
        </div>
    );
};
